import moment from 'moment';
import { Sort } from '../../../icons/Sort.icon';
import { ProfileLogo } from '../../ambient_solo/components/baseComponents';
import { message, Tooltip } from 'antd';
import { CopiesIcon } from '../../../icons';
import { ChatIcon } from '../../../icons/Chaticon.icon';
import AppointmentActionMenu from './AppointmentsMenu';
import AppointmentStatus from './AppointmentStatus';
import { analytics } from 'src/services';

export const doctor_nameSorter = (a, b) => {
  return a.practitioner_Name.localeCompare(b.practitioner_Name);
};

export const auraStatusSorter = (a, b) => {
  return a.encounterInVisitStatus.localeCompare(b.encounterInVisitStatus);
};

const handleChatIconClick = (url, event, record, user) => {
  event.stopPropagation();
  if (url) {
    analytics.track('Opened Lumi Chat', {
      appointment_date: record?.appointmentDateTime,
      appointment_id: record?.appointment_id,
      appointment_status: record?.intakeStatus,
      practitioner_name: record?.practitioner_Name,
      email: user?.email,
    });
    window.open(url, '_blank'); // Open the virtual care site URL
  }
};
export const columns = (
  filteredData,
  onCellClick,
  practitionersAndPatients,
  currentPractitioner,
  hasVCAProcessedWorkflowAccess,
  user,
  setDeleteText,
  setIsDeleteOpen,
  setQRCodeURL,
  setIsQRCodeOpen,
  setEditAppointmentOpen,
  setIsnotificationHistoryOpen,
  setShowConvertAppointmentToAuraModal,
  setSelectedAppointmentForAuraEncounter,
  setFilteredData,
  setData,
  setStoreRecord,
  hideDateTime,
  sortInfo = { sortBy: 'start_date', sortDirection: 'desc' },
  onSort = null
) => {
  return [
    {
      title: (
        <span className="font-[700]">
          Practitioner
          {filteredData?.length > 0 && <Sort className={'sort-icon-doctor'} />}
        </span>
      ),
      dataIndex: 'practitioner_Name',
      key: 'practitioner_Name',
      defaultSortOrder:
        sortInfo.sortBy === 'practitioner_name'
          ? sortInfo.sortDirection === 'asc'
            ? 'ascend'
            : 'descend'
          : null,
      onCell: onCellClick,
      onHeaderCell: () => ({
        onClick: () => {
          if (onSort) {
            const currentDirection =
              sortInfo.sortBy === 'practitioner_name' &&
              sortInfo.sortDirection === 'asc'
                ? 'asc'
                : 'desc';
            const newDirection = currentDirection === 'asc' ? 'desc' : 'asc';
            onSort('practitioner_name', newDirection);
          }
        },
        style: { cursor: 'pointer' },
      }),
      width: hideDateTime ? '22%' : undefined,
      render: (text, record) => {
        return (
          <>
            <div className="flex items-center ">
              <ProfileLogo
                name={`${record.practitioner_firstName} ${record.practitioner_lastName}`}
                className={'profile-popover-logo mr-1 sm:mr-2 lg:mr-3'}
              />
              <div className="">{record.practitioner_Name}</div>
            </div>
          </>
        );
      },
    },
    {
      title: (
        <span className="font-[700]">
          {' '}
          Appointment{' '}
          {filteredData?.length > 0 && (
            <Sort className={'sort-icon-appointment'} />
          )}{' '}
        </span>
      ),
      dataIndex: 'appointmentDateTime',
      key: 'appointmentDateTime',
      defaultSortOrder:
        sortInfo.sortBy === 'appointmentDateTime'
          ? sortInfo.sortDirection === 'asc'
            ? 'ascend'
            : 'descend'
          : null,
      onCell: onCellClick,
      onHeaderCell: () => ({
        onClick: () => {
          if (onSort) {
            const currentDirection =
              (sortInfo.sortBy === 'appointmentDateTime' ||
                sortInfo.sortBy === 'start_date') &&
              sortInfo.sortDirection === 'asc'
                ? 'asc'
                : 'desc';
            const newDirection = currentDirection === 'asc' ? 'desc' : 'asc';
            onSort('start_date', newDirection);
          }
        },
        style: { cursor: 'pointer' },
      }),
      width: hideDateTime ? '20%' : '15%',
      render: (text, record) => {
        const textColorClass = record.isExpired
          ? 'expired-appointment-color'
          : '';
        const { date, time } = text;
        const localDateString = moment
          .utc(date, 'MMM Do, YYYY hh:mm A')
          .format('MMM Do, YYYY');
        const localTimeString = moment.utc(time, 'hh:mm A').format('h:mm A');

        return record.isExpired ? (
          <Tooltip title="Appointment is expired" placement="top">
            <div>
              {currentPractitioner?.org_settings?.show_appointment_time ? (
                <span className={textColorClass}>{localDateString}</span>
              ) : (
                <span className={textColorClass}>
                  {moment(date, 'MMM Do, YYYY hh:mm A').format('MMM Do, YYYY')}
                </span>
              )}
            </div>
            {currentPractitioner?.org_settings?.show_appointment_time && (
              <div className={`${textColorClass} start-time`}>
                {localTimeString}
              </div>
            )}
          </Tooltip>
        ) : (
          <Tooltip
            title={
              <span
                onClick={(e) => {
                  // Copy the tooltip text to the clipboard
                  navigator.clipboard.writeText(`${record?.appointment_id}`);
                  e.stopPropagation(); // Prevents triggering any other actions
                  // Show a confirmation toast
                  message.success('Appointment ID copied!', 1); // 1 second duration
                }}
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
              >
                Appointment ID: {record?.appointment_id}
                <CopiesIcon height="15" width="15" color="#000" />
              </span>
            }
            placement="topLeft"
          >
            <>
              {currentPractitioner?.org_settings?.show_appointment_time ? (
                <span className={textColorClass}>{localDateString}</span>
              ) : (
                <span className={textColorClass}>
                  {moment(date, 'MMM Do, YYYY hh:mm A').format('MMM Do, YYYY')}
                </span>
              )}
              {currentPractitioner?.org_settings?.show_appointment_time && (
                <div className={`${textColorClass} start-time`}>
                  {localTimeString}
                </div>
              )}
            </>
          </Tooltip>
        );
      },
    },
    {
      title: (
        <span className="font-[700]">
          {' '}
          Patient
          <Tooltip title="Sort by last name" placement="top">
            <>
              {filteredData?.length > 0 && (
                <Sort className={'sort-icon-patient'} />
              )}
            </>
          </Tooltip>
        </span>
      ),
      dataIndex: 'patient_Name',
      key: 'patient_Name',
      defaultSortOrder:
        sortInfo.sortBy === 'patient_name'
          ? sortInfo.sortDirection === 'asc'
            ? 'ascend'
            : 'descend'
          : null,
      onHeaderCell: () => ({
        onClick: () => {
          if (onSort) {
            const currentDirection =
              sortInfo.sortBy === 'patient_name' &&
              sortInfo.sortDirection === 'asc'
                ? 'asc'
                : 'desc';
            const newDirection = currentDirection === 'asc' ? 'desc' : 'asc';
            onSort('patient_name', newDirection);
          }
        },
        style: { cursor: 'pointer' },
      }),
      width: hideDateTime ? '22%' : undefined,
      render: (text, record) => {
        const nameParts = record?.patient_Name
          .split('"')
          .filter((part) => part.trim() !== '');
        return (
          <div>
            <div className="icon">
              <Tooltip
                title={
                  <>
                    <div
                      onClick={(e) => {
                        navigator.clipboard.writeText(`${record?.patient_id}`);
                        e.stopPropagation();
                        message.success('IH ID copied!', 1);
                      }}
                      style={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                      }}
                    >
                      <span style={{ fontWeight: 600 }}>IH ID:</span>
                      <span
                        className={`${record?.patient_ehr_id ? 'ml-4' : ''}`}
                        style={{ fontFamily: 'monospace', fontSize: '1.1em' }}
                      >
                        {record?.patient_id}
                      </span>
                      <CopiesIcon height="15" width="15" color="#000" />
                    </div>
                    {record?.patient_ehr_id && (
                      <div
                        onClick={(e) => {
                          navigator.clipboard.writeText(
                            `${record?.patient_ehr_id}`
                          );
                          e.stopPropagation();
                          message.success('EHR ID copied!', 1);
                        }}
                        style={{
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                        }}
                      >
                        <span style={{ fontWeight: 600 }}>EHR ID:</span>
                        <span
                          className="ml-1"
                          style={{ fontFamily: 'monospace', fontSize: '1.1em' }}
                        >
                          {record?.patient_ehr_id}
                        </span>
                        <CopiesIcon height="15" width="15" color="#000" />
                      </div>
                    )}
                  </>
                }
                placement="topLeft"
              >
                <div className="name">{nameParts.join(' ')}</div>
              </Tooltip>
              {record?.llm_chat_url === null ||
              record?.intakeStatus === 'Unavailable' ? (
                ''
              ) : (
                <Tooltip title="View patient chat" placement="topLeft">
                  <>
                    <div
                      className="chat-icon ml-4 "
                      style={{
                        transform: 'scale(1.2)',
                        transition: 'transform 0.3s',
                      }}
                    >
                      <ChatIcon
                        onClick={(event) =>
                          handleChatIconClick(
                            record?.llm_chat_url + '?from_care_connect=true',
                            event,
                            record,
                            user
                          )
                        }
                        className="chat-icon"
                      />
                    </div>
                  </>
                </Tooltip>
              )}
            </div>
            <div className="dob">{record?.dateofBirth}</div>
          </div>
        );
      },
      onCell: onCellClick,
    },
    {
      title: (
        <span className="font-[700]">
          {' '}
          Condition{' '}
          {filteredData?.length > 0 && (
            <Sort className={'sort-icon-condition'} />
          )}{' '}
        </span>
      ),
      dataIndex: 'condition_name',
      key: 'condition_name',
      defaultSortOrder:
        sortInfo.sortBy === 'condition_name'
          ? sortInfo.sortDirection === 'asc'
            ? 'ascend'
            : 'descend'
          : null,
      onCell: onCellClick,
      onHeaderCell: () => ({
        onClick: () => {
          if (onSort) {
            const currentDirection =
              sortInfo.sortBy === 'condition_name' &&
              sortInfo.sortDirection === 'asc'
                ? 'asc'
                : 'desc';
            const newDirection = currentDirection === 'asc' ? 'desc' : 'asc';
            onSort('condition_name', newDirection);
          }
        },
        style: { cursor: 'pointer' },
      }),
      width: hideDateTime ? '22%' : 'undefined',
    },
    // {
    //   title: (
    //     <span className="font-[700]">
    //       {' '}
    //       Aura status{' '}
    //       {filteredData?.length > 0 && (
    //         <Sort className={'sort-icon-aura-status'} />
    //       )}{' '}
    //     </span>
    //   ),
    //   sorter: filteredData?.length > 0 && auraStatusSorter,
    //   dataIndex: 'encounterInVisitStatus',
    //   key: 'encounterInVisitStatus',
    //   width: '15%',
    //   render: (text, record) => {
    //     const statusOptions = {
    //       completed: {
    //         title: 'Completed',
    //         className:
    //           'text-[#1ec990] bg-[#eefaf4] h-8 flex items-center justify-center rounded-full',
    //       },
    //       inprogress: {
    //         title: 'In Progress',
    //         className:
    //           'text-[#ff6f00] bg-[#ffe1ca] h-8 flex items-center justify-center rounded-full',
    //       },
    //       new: {
    //         title: 'Not Started',
    //         className:
    //           'text-[#5a8dda] bg-[#e7f1ff] h-8 flex items-center justify-center rounded-full',
    //       },
    //     };
    //     const status = statusOptions[record?.encounterInVisitStatus];
    //     return (
    //       <span
    //         className={status?.className}
    //         style={{
    //           padding: '5px 10px',
    //           width: 'fit-content',
    //         }}
    //       >
    //         {status?.title}
    //       </span>
    //     );
    //   },
    // },
    {
      title: <span className="font-[700] flex justify-start">Status </span>,
      key: 'status',
      width: '20%',
      render: (text, record) => (
        <AppointmentStatus
          record={record}
          hasVCAProcessedWorkflowAccess={hasVCAProcessedWorkflowAccess}
        />
      ),
    },
    {
      title: ' ',
      key: 'actions',
      dataIndex: 'actions',
      width: hideDateTime ? '5%' : '1%',

      render: (text, record) => {
        return (
          <AppointmentActionMenu
            record={record}
            setDeleteText={setDeleteText}
            setIsDeleteOpen={setIsDeleteOpen}
            setQRCodeURL={setQRCodeURL}
            setIsQRCodeOpen={setIsQRCodeOpen}
            setEditAppointmentOpen={setEditAppointmentOpen}
            setStoreRecord={setStoreRecord}
            setIsnotificationHistoryOpen={setIsnotificationHistoryOpen}
            setShowConvertAppointmentToAuraModal={
              setShowConvertAppointmentToAuraModal
            }
            setSelectedAppointmentForAuraEncounter={
              setSelectedAppointmentForAuraEncounter
            }
            setFilteredData={setFilteredData}
            setData={setData}
          />
        );
      },
    },
  ].filter(Boolean);
};
